import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import VideoSource from '../VideoSource';
import Constants from '../../pages/App/constants';

import './style.scss';

class Article extends PureComponent {
  render() {
    const imageURL = `url(${this.props.item.largeImage || this.props.item.image})`;

    return (
      <div className="article-card-item">
        <div className={this.props.pushRight && 'right'}>
          <Link to={`/articles/${this.props.item.id}`}>
            <h3 dangerouslySetInnerHTML={{ __html: this.props.item.title }}></h3>
          </Link>
          <span dangerouslySetInnerHTML={{ __html: this.props.item.longIntro }}></span>
          <Link to={`/articles/${this.props.item.id}`}>
            <Icon
              icon="more"
              alt={this.props.item.title}
              size={Constants.sizeReadMore}
            />
          </Link>
        </div>

        <div>
          {this.props.item.videoId
            ? (
              <VideoSource
                scaleWidth={window.screen.width}
                videoSrc={this.props.item.videoUrl}
                placeholder={this.props.item.image}
                title={this.props.item.title}
              />
            )
            : (
              <Link to={`/articles/${this.props.item.id}`}>
                <div className="img" style={{ backgroundImage: imageURL }} />
              </Link>
            )}
        </div>
      </div>
    );
  }
}

Article.propTypes = {
  item: PropTypes.object.isRequired,
  pushRight: PropTypes.bool,
};

Article.defaultProps = {
  pushRight: false,
};

export default Article;
